module.exports = __webpack_public_path__ + "f09a9a81caac061aa21a5c5b7c51075a.gif";